import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NotificationRequestStatus } from '../../models/Notification';

@Component({
    selector: 'app-notification-request-status',
    template: `
<span class="badge"
      [title]="date ? (date | appDate:'+') : (error || '')"
      [class.text-bg-secondary]="value == 'Pending'"
      [class.text-bg-danger]="value == 'Error'"
      [class.text-bg-success]="value == 'Sent'">
    {{'notification_requestStatus' + value | translate}}
</span>
`
})
export class NotificationRequestStatusComponent {
    @Input() value: NotificationRequestStatus;
    @Input() date?: Date;
    @Input() error?: string;
}
